import Vue from "vue";
import Router from "vue-router";

import ArcoscanDemo from "@/components/classification/ArcoscanDemo";
import Firebase from "firebase/app";
import "firebase/auth";

Vue.use(Router);

let routes = [
  {
    path: "/",
    name: "home",
    component: ArcoscanDemo,
    meta: {
      requiresAuth: false
    }
  },
  {
    path:"/arcoscan_demo",
    name:"arcoscan_demo",
    component: ArcoscanDemo,
    meta:{
      requiresAuth:false
    },
    props:{
      classifierNames: ["video_age_verification"]
    }
  }
];

let router = new Router({
  //   base: common.state.basePath,
  mode: "history",
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

// Check before each page load whether the page requires authentication/
// if it does check whether the user is signed into the web app or
// redirect to the sign-in page to enable them to sign-in
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    const currentUser = Firebase.auth().currentUser;
    if (!currentUser) {
      next({ path: "/sign-in", query: { redirect: to.fullPath } });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
